import React from 'react'
import PropTypes from 'prop-types'

const HEADINGS = { and: 'All of:', or: 'Any of:' }

const Outline = ({ outline }) => {
  if (typeof outline === 'string') return <span>{outline}</span>
  return (
    <>
      <span className="text-muted">{HEADINGS[outline.op] || 'All of:'}</span>
      <ul className="mb-0 ps-3">
        {outline.items.map((item, index) => (
          <li key={index}>
            <Outline outline={item} />
          </li>
        ))}
      </ul>
    </>
  )
}

Outline.propTypes = { outline: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired }

// A chart's own filters as a short outline, "Any of" / "All of" rather than OR / AND. The dataset's
// filters apply to every chart on it, so they are only mentioned, not listed.
const ChartFilterSummary = ({ outline }) => (
  <div className="small" data-testid="chart-filter-summary">
    <div className="fw-bold mb-1">This chart also filters to:</div>
    <Outline outline={outline} />
    <div className="text-muted mt-2">Plus the dataset&apos;s filters.</div>
  </div>
)

ChartFilterSummary.propTypes = { outline: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired }

export default ChartFilterSummary
